import { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { lyfshortLoginSuccess, login, loginFailed, loginSuccess } from "../slices/auth/authSlice";
import { createExpertProfile, getExpertProfile, getTripLinkUserSignin, updateExpertProfile } from "../../utils/triplinkService";
import {
  createExpert,
  createExpertFailed,
  createExpertSuccess,
  fetchExpert,
  fetchExpertFailed,
  fetchExpertSuccess,
  updateExpert,
  updateExpertFailed,
  updateExpertSuccess
} from "../slices/expert/expertSlice";
import {
  fetchEntitledFeatures,
} from '../slices/subscriptions/subscriptionsSlice';
import { AppDispatch } from "../../store";
import {
  fetchBusinessMembers
} from "../slices/businessMember/businessMemberSlice";
import { fetchBusiness } from "../slices/business/businessSlice";
import { fetchLeads } from "../slices/leads/leadsSlice";
import { fetchMeetings } from "../slices/meetings/meetingsSlice";

const triplinkServiceMiddleware: Middleware = (store: MiddlewareAPI<AppDispatch>) => (next) => async (action) => {
  const state = store.getState()

  next(action)

  if (lyfshortLoginSuccess.match(action)) {
    store.dispatch(login())
  }

  if (login.match(action)) {
    await getTripLinkUserSignin(state.accessToken.body)
      .then((user) => {
        store.dispatch(loginSuccess(user))
        store.dispatch(fetchExpert({
          requiresAccessToken: true
        }))
        store.dispatch(fetchEntitledFeatures())
      })
      .catch(err => {
        console.warn(err)
        store.dispatch(loginFailed(err))
      })
  } else if (fetchExpert.match(action)) {
    await getExpertProfile(state.accessToken.body)
      .then((expert) => {
        store.dispatch(fetchExpertSuccess(expert))
        store.dispatch(fetchBusinessMembers())
        store.dispatch(fetchBusiness())
        store.dispatch(fetchLeads())
        store.dispatch(fetchMeetings())
      })
      .catch(err => {
        store.dispatch(fetchExpertFailed())
      })
  } else if (createExpert.match(action)) {
    await createExpertProfile(state.accessToken.body)
      .then((expert) => {
        store.dispatch(createExpertSuccess(expert))
      })
      .catch(err => {
        store.dispatch(createExpertFailed())
      })
  } else if (updateExpert.match(action)) {
    await updateExpertProfile(state.accessToken.body, action.payload.updates)
      .then((expert) => {
        store.dispatch(updateExpertSuccess(expert))
      })
      .catch(err => {
        store.dispatch(updateExpertFailed())
      })
  }
}

export default triplinkServiceMiddleware;
